module.exports = __webpack_public_path__ + "static/media/step3-wd4.d0d442af.svg";